import CityPageTemplate from './CityPageTemplate';

export default function CasselberryPage() {
  return (
    <CityPageTemplate
      city="Casselberry"
      county="Seminole"
      slug="casselberry"
      zipCodes={['32707', '32730']}
      neighborhoods={['Lake Concord', 'Deer Run', 'Sterling Park', 'Casselberry Commons', 'Triplet Lake']}
      localContext="Nestled between Lake Concord and Triplet Lake, Casselberry is a Seminole County community where families and businesses rely on dependable, thorough cleaning services."
      metaDescription="Professional residential and commercial cleaning services in Casselberry, FL. Serving ZIP codes 32707 & 32730. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
